import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/access/page';

export const Route = createFileRoute('/_app/_chat/apps/$id/access')({
  component: Page,
});
